import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCQ0ayHg-PtDvyt39I9cEcFX0EJDk7b960",
    authDomain: "bacolod-ai-assistant.firebaseapp.com",
    projectId: "bacolod-ai-assistant",
    storageBucket: "bacolod-ai-assistant.firebasestorage.app",
    messagingSenderId: "817959856576",
    appId: "1:817959856576:web:e8c4cc10f684f023b44025",
    measurementId: "G-P1SE2D19WK"
};

export const firebaseApp = initializeApp(firebaseConfig);
// Initialize Analytics (optional, for web)
export const analytics = getAnalytics(firebaseApp);
export const db = getFirestore(firebaseApp);